import { EditorView } from 'prosemirror-view'
import { PreviewContentData } from 'common/Prose/nodeViews/AISuggestion/PreviewContentData'
import { parseRevisionContent } from 'components/AIRevision/parseRevisionContent'

interface Props {
  markdown: string
  view: EditorView
  className?: string
}

export const PreviewMarkdown = ({ markdown, view, className }: Props) => {
  const contentData = parseRevisionContent(view.state.schema, markdown).content

  if (!contentData) {
    return null
  }

  return <PreviewContentData contentData={JSON.stringify(contentData.toJSON())} view={view} className={className} />
}
